import { defineComponent as _defineComponent } from 'vue'
import { AdminTrade } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeProfitInfo',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: AdminTrade;
};



const partnerCommissionPercentage = computed(() => {
  if (props.trade.partnerCommissionPercentage > -1) {
    return `${(props.trade.partnerCommissionPercentage * 100).toFixed(1)}`;
  }
  return '';
});

return { __sfc: true,props, partnerCommissionPercentage, formatCurrencyValue }
}

})